import React from "react";
import "../assets/styles/footer.css";
import { FaLinkedin, FaInstagram, FaFacebookF } from "react-icons/fa";
import Logo from "../assets/images/nav1.svg";
import f1 from "../assets/images/f1.svg";
import f2 from "../assets/images/f2.svg";
import f3 from "../assets/images/f3.svg";
import f4 from "../assets/images/f4.svg";
import f5 from "../assets/images/f5.svg";
import f6 from "../assets/images/f6.svg";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-content">
        <div className="footer-column">
          <img
            src={Logo}
            className="footer-logo-img"
            alt="Syncrones Logo"
            style={{ height: "40px", marginRight: "100px", marginLeft: "-20%" }}
          />
          <p className="para">Join the Syncrones Community</p>
          <p className="para">Stay updated with the latest in AI and technology.</p>
          <p>Follow Us On.</p>
        </div>

        <div className="footer-column">
          <h4>Services</h4>
          <ul>
            <li>About</li>
            <li>AI Solutions</li>
            <li>Website Development</li>
            <li>Mobile App Development</li>
            <li>UI/UX Design</li>
            <li>Software Testing Services</li>
          </ul>
        </div>

        <div className="footer-column">
          <h4 className="support">Support</h4>
          <ul>
            <li className="support">Blog</li>
            <li className="support">Our Products</li>
          </ul>
        </div>
        <div class="blur-circle left"></div>
        <div class="blur-circle right"></div> 
        <div className="footer-column">
          <h4>Contact</h4>
          <ul>
            <li>
              <img src={f1} alt="Location Icon" className="footer-icon" /> 20 Upton Cir, Derrimut VIC 3026, Australia
            </li>
            <li>
              <img src={f2} alt="Phone Icon" className="footer-icon" />
              <span>+61 449 970 773</span> {/* Wrap the phone number */}
            </li>
            <li>
              <img src={f3} alt="Email Icon" className="footer-icon" /> info@syncrones.com
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-terms">
        <p>Terms      Privacy     Cookies</p>
      </div>

      {/* Move the social icons to the bottom */}
      <div className="footer-social-icons">
        <a href="https://www.linkedin.com/company/syncrones/" className="social-icon">
          <img src={f6} alt="LinkedIn" className="social-icon-img" />
        </a>
        <a href="https://www.instagram.com/syncrones_soft?igsh=MWMyNHdjb2J6dGtqOA%3D%3D&utm_source=qr" className="social-icon">
          <img src={f5} alt="Instagram" className="social-icon-img" />
        </a>
        <a href="https://www.facebook.com/share/14hBuKYMUg/?mibextid=wwXIfr" className="social-icon">
          <img src={f4} alt="Facebook" className="social-icon-img" />
        </a>
      </div>


      <div className="footer-bottom">
        <p>© 2024 Syncrones. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
